
export default {
    $el: null,
    $optionsContainer: null,
    $startLabel: null,
    $endLabel: null,
    rangeStartDate: null,
    rangeEndDate: null,

    props: {
    },

    connect() {
        this.$el = $(this.el);
        this.rangeStartDate = dayjs().startOf('year');
        this.rangeEndDate = dayjs().endOf('year');

        this.$el.daterangepicker({
            startDate: this.rangeStartDate,
            endDate: this.rangeEndDate,
            alwaysShowCalendars: true,
            showDropdowns: false,
            showCustomRangeLabel: false,
            ranges: this.getRanges(),
            applyButtonClasses: 'btn-primary d-inline-block',
            cancelButtonClasses: 'btn-default d-none', // hide button
            locale: {
                "format": "DD.MM.YYYY",
                "separator": " - ",
                "applyLabel": ("Anwenden"),
                "cancelLabel": ("Alles anzeigen"),
                "fromLabel": ("von"),
                "toLabel": ("bis"),
                "customRangeLabel": ("Benuzerdefinierter Zeitraum"),
                "weekLabel": ("W"),
                "daysOfWeek": [
                    ("Su"),
                    ("Mo"),
                    ("Di"),
                    ("Mi"),
                    ("Do"),
                    ("Fr"),
                    ("Sa")
                ],
                "monthNames": [
                    ("Januar"),
                    ("Februar"),
                    ("März"),
                    ("April"),
                    ("Mai"),
                    ("Juni"),
                    ("Juli"),
                    ("August"),
                    ("September"),
                    ("Oktober"),
                    ("November"),
                    ("Dezember")
                ],
                "firstDay": 1
            }
        }, function (start, end) {
            var picker = $(this.el).data('daterangepicker');
            if (picker) {
                picker.container.find('.input-start').val(picker.startDate.format('DD.MM.YYYY'));
                picker.container.find('.input-end').val(picker.endDate.format('DD.MM.YYYY'));
            }
        });

        this.$el.on('show.daterangepicker', this.showPicker);
        this.$el.on('apply.daterangepicker', this.applyPicker);
        this.$el.on('cancel.daterangepicker', this.cancelPicker);
        this.$el.on('selected.date.start', this.datesUpdated);
        this.$el.on('selected.date.end', this.datesUpdated);
    },

    methods: {
        getRanges() {
            let ranges = {};

            ranges[('Aktuelles Jahr')] = [
                dayjs().startOf('year').$d,
                dayjs().endOf('year').$d
            ];
            ranges[('Letztes Jahr')] = [
                dayjs().startOf('year').add(-1, 'year').$d,
                dayjs().endOf('year').add(-1, 'year').$d
            ];
            ranges[('Aktueller Monat')] = [
                dayjs().startOf('month').$d,
                dayjs().endOf('month').$d
            ];
            ranges[('Letzter Monat')] = [
                dayjs().startOf('month').add(-1, 'month').$d,
                dayjs().endOf('month').add(-1, 'month').$d
            ];

            console.log(ranges);
            return ranges;
        },
        showPicker(ev, picker) {
            let container = $(picker.container[0]);

            if (container.find('.date-inputs').length === 0) {
                let startDate = dayjs().startOf('year');
                let endDate = dayjs().endOf('year');

                var dateInputsContainer = $('<div class="date-inputs"></div>');
                var day1Select = $('<input type="text" class="form-control input-start" value="'+startDate.format('DD.MM.YYYY')+'" />');
                var day2Select = $('<input type="text" class="form-control input-end" value="'+endDate.format('DD.MM.YYYY')+'" />');
                dateInputsContainer.append(day1Select);
                dateInputsContainer.append('<div class="px-3">-</div>');
                dateInputsContainer.append(day2Select);
                container.prepend(dateInputsContainer);

                var cfg = { alias: "datetime", inputFormat: "dd.mm.yyyy", outputFormat: "dd.mm.yyyy" };
                day1Select.inputmask(cfg);
                day2Select.inputmask(cfg);

                day1Select.on('keyup', this.parseStartInput);
                day2Select.on('keyup', this.parseEndInput);
            } else {
                container.find('.input-start').val(picker.startDate.format('DD.MM.YYYY'));
                container.find('.input-end').val(picker.endDate.format('DD.MM.YYYY'));
            }

            container.find('.input-start').focus();
        },
        datesUpdated(ev, picker) {
            picker.container.find('.input-start').val(picker.startDate.format('DD.MM.YYYY'));
            if (picker.endDate.isValid()) {
                picker.container.find('.input-end').val(picker.endDate.format('DD.MM.YYYY'));
            }
        },
        applyPicker(ev, picker) {
            if (picker.startDate.isValid()) {
                picker.element.find('label').text(`${picker.startDate.format('DD.MM.YYYY')} - ${picker.endDate.format('DD.MM.YYYY')}`);
                picker.element.find('[name="filter[DateFrom]"]').val(picker.startDate.format('YYYY-MM-DD'));
                picker.element.find('[name="filter[DateTo]"]').val(picker.endDate.format('YYYY-MM-DD'));

                $('body').trigger('daterangepicker.changed', {picker});
            }
        },
        cancelPicker(ev, picker) {
            $('body').trigger('daterangepicker.changed', {picker});
        },
        autoRange(ev, picker) {
            $('body').trigger('daterangepicker.changed', {picker});
        },
        parseStartInput(ev) {
            var dateParts = $(ev.target).val().split('.');
            if (dateParts.length === 3) {
                var date = dayjs(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]} 00:00`);
                if (date.isValid()) {
                    var picker = $(this.el).data('daterangepicker');
                    picker.setStartDate(date.$d);
                    picker.renderCalendar('left');
                    picker.renderCalendar('right');
                }
            }
        },
        parseEndInput(ev) {
            var dateParts = $(ev.target).val().split('.');
            if (dateParts.length === 3) {
                var date = dayjs(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]} 00:00`);
                if (date.isValid()) {
                    var picker = $(this.el).data('daterangepicker');
                    picker.setEndDate(date.$d);
                    picker.renderCalendar('left');
                    picker.renderCalendar('right');
                }
            }
        },
    },

    events: [{
        name: 'click',
        handler(ev) {
        }
    }],

}
